var render = function render(_c,_vm){return _c('a-default-stamp',{attrs:{"color":"warning","rotation":3,"border":"0.2rem dotted","radius":"0"}},[_vm._v("Modifié")])
}
var staticRenderFns = []

export { render, staticRenderFns }